// extracted by mini-css-extract-plugin
export default {"background":"styles_background__JLrRx","arrow":"styles_arrow__eEQ1m","container":"styles_container__GQt3V","title":"styles_title__-jDdr","image":"styles_image__nFAP2"};